import type { ForNodeType } from "@/components/features/_model/types";

type Props = {
	name: ForNodeType<string>;
	onSetViewModel: (
		values: {
			key: "name";
			value: ForNodeType<string>;
		}[],
	) => void;
};

export const useOptionName = ({ name, onSetViewModel }: Props) => {
	const onSetName = (input: string) => {
		onSetViewModel([{ key: "name", value: { ...name, value: input } }]);
	};

	return {
		name,
		onSetName,
	};
};
